import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'outline' | 'ghost'

export const buttonStyles = (variant: ButtonVariant = 'primary', className?: string): string => {
    return cn(
        'inline-flex h-11 items-center justify-center gap-2 rounded-full px-6 text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-60',
        variant === 'primary' && 'bg-primary text-primary-foreground hover:bg-primary/85',
        variant === 'outline' && 'border border-input bg-transparent text-foreground hover:border-foreground/30 hover:bg-accent',
        variant === 'ghost' && 'text-foreground hover:bg-accent',
        className
    )
}
